export class MoveBookingsRequestDTO {
    constructor(
        public bookingId: string,
        public tableIds: string[],
        public start: string | null
    ) { }
}
